import moment from "moment";
import { getMediaTypeFromProduct } from "../../utils/mediaCalculations";

export const AIRPORT_TIMESLOT_OPTIONS = [10, 20, 30, 40, 50, 60];

export function isAirportMediaListing(productOrForm) {
  if (!productOrForm) return false;
  if (getMediaTypeFromProduct(productOrForm) === "Airport") return true;
  const journey = String(productOrForm?.mediaJourney || "").toLowerCase().trim();
  if (journey === "airport") return true;
  const mc = String(productOrForm?.mediaCategory || "").toLowerCase().trim();
  if (mc === "airport") return true;
  if (productOrForm?.ProductSubCategoryName === "Airport Screens") return true;
  return false;
}

export function getAirportTotalOrderQty(variation) {
  if (!variation) return "";
  const raw =
    variation.maxOrderQuantityunit ??
    variation.minOrderQuantityunit ??
    variation.MaxOrderQuantity ??
    variation.MinOrderQuantity;
  return raw != null && raw !== "" ? raw : "";
}

export function getMaxTimeslotOptionsAfterMin(minValue, options = AIRPORT_TIMESLOT_OPTIONS) {
  const min = Number(minValue);
  if (!Number.isFinite(min) || min <= 0) return [...options];
  return options.filter((v) => v > min);
}

export function getVoucherDeliveryTypeFromProduct(product) {
  if (!product) return "";
  const raw = product.voucherDeliveryType ?? product.VoucherDeliveryType ?? "";
  const delivery = String(raw).trim().toLowerCase();
  if (delivery === "digital" || delivery === "physical" || delivery === "both") {
    return delivery;
  }
  const redemption = String(
    product.redemptionType ?? product.RedemptionType ?? "",
  )
    .trim()
    .toLowerCase();
  if (redemption === "offline") return "physical";
  if (redemption === "both") return "both";
  if (redemption === "online") return "digital";
  return "";
}

export function isDigitalVoucherProduct(product) {
  if (!product) return false;
  const listingType = product.productType ?? product.ListingType ?? "";
  if (listingType !== "Voucher") return false;
  return getVoucherDeliveryTypeFromProduct(product) === "digital";
}

export function getDaysBetweenDates(startDate, endDate, online) {
  if (online) {
    const start = moment(startDate);
    const end = moment(endDate);
    return end.diff(start, "days") + 1;
  }
  const start = new Date(startDate);
  const end = new Date(endDate);
  const timeDiff = end.getTime() - start.getTime();
  return Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1;
}

export function ReturnDaysFromTimeline(timeline) {
  if (timeline === "Day") return 0;
  if (timeline === "Week") return 6;
  if (timeline === "Month") return 29;
  if (timeline === "Year") return 364;
  return 0;
}

export function getDates(startDate, endDate, mediaVariation) {
  const dates = [];
  let currentDate = new Date(startDate);
  const end = new Date(endDate);
  while (currentDate <= end) {
    dates.push({
      startDate: new Date(currentDate).toJSON(),
      endDate: new Date(currentDate).toJSON(),
      minOrderQuantityunit: Number(mediaVariation?.minOrderQuantityunit ?? 0),
      maxOrderQuantityunit: Number(mediaVariation?.maxOrderQuantityunit ?? 0),
      minTimeslotSeconds: Number(mediaVariation?.minTimeslotSeconds ?? 0),
      maxTimeslotSeconds: Number(mediaVariation?.maxTimeslotSeconds ?? 0),
    });
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dates;
}

export function checkIfDateExists(dateArr, newStartDate, newEndDate) {
  for (let i = 0; i < dateArr.length; i++) {
    const { startDate, endDate } = dateArr[i];
    if (
      (newStartDate >= startDate && newStartDate <= endDate) ||
      (newEndDate >= startDate && newEndDate <= endDate)
    ) {
      return true;
    }
  }
  return false;
}

export function countDaysfromTimeline(value, timeline, mediaVariation) {
  if (timeline === "Week") return value * 7;
  if (timeline === "Month") return value * 30;
  if (timeline === "Year") return value * 365;
  if (timeline === "Day") return value;
  if (mediaVariation?.unit === "Spot") return mediaVariation?.maxOrderQuantityunit ?? value;
  if (timeline === "One Time") return value;
  return value;
}

export function formatDate(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

export function deepEqual(obj1, obj2) {
  if (obj1 === obj2) return true;
  if (
    typeof obj1 !== "object" ||
    obj1 === null ||
    typeof obj2 !== "object" ||
    obj2 === null
  ) {
    return false;
  }
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) return false;
  for (const key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }
  return true;
}

export function filterMultiples(array, multiple) {
  return array.filter((value) => value % multiple === 0);
}
